import { render, staticRenderFns } from "./system_admin_add.vue?vue&type=template&id=2ce972e8&scoped=true&"
import script from "./system_admin_add.vue?vue&type=script&lang=js&"
export * from "./system_admin_add.vue?vue&type=script&lang=js&"
import style0 from "./system_admin_add.vue?vue&type=style&index=0&id=2ce972e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce972e8",
  null
  
)

export default component.exports